export default __webpack_public_path__ + "static/media/bloc-calculette@2x.d110beed.png";